import React, { useEffect, useState } from "react";
import { toPng } from "html-to-image";
import "../styles/OrderedMaterials.css";

const OrderedMaterials = ({ materials, selectedData }) => {
  const downloadTableAsPng = () => {
    const node = document.getElementById("material-table");
    toPng(node)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "materials.png";
        link.click();
      })
      .catch((err) => {
        console.error("Error downloading table as PNG:", err);
      });
  };

  return (
    <div>
      {materials.length > 0 && (
        <>
          <button onClick={downloadTableAsPng}>Download Table as PNG</button>
          <table
            id="material-table"
            className="tbl"
            style={{ width: "100%", borderCollapse: "collapse" }}
          >
            <thead>
              <tr>
                <th
                  colSpan="5"
                  style={{
                    textAlign: "center",
                    backgroundColor: "#f2f2f2",
                    color: "black",
                  }}
                >
                  {selectedData.unitObj?.UnitName}
                </th>
              </tr>
              <tr>
                <th style={{ backgroundColor: "#f2f2f2", color: "black" }}>
                  Branch
                </th>
                <td style={{ backgroundColor: "#fff" }}>
                  {" "}
                  {selectedData.branchObj?.BranchName}
                </td>
                <td style={{ backgroundColor: "#fff" }}></td>
                <th style={{ backgroundColor: "#f2f2f2", color: "black" }}>
                  Month
                </th>
                <td style={{ backgroundColor: "#fff" }}>
                  {selectedData.monthObj?.MonthName}
                </td>
              </tr>
              <tr>
                <th style={{ backgroundColor: "#f2f2f2", color: "black" }}>
                  S.No
                </th>
                <th style={{ backgroundColor: "#f2f2f2", color: "black" }}>
                  Material Description
                </th>
                <th style={{ backgroundColor: "#f2f2f2", color: "black" }}>
                  Quantity
                </th>
                <th style={{ backgroundColor: "#f2f2f2", color: "black" }}>
                  Price
                </th>
                <th style={{ backgroundColor: "#f2f2f2", color: "black" }}>
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {materials.map((material, index) => (
                <tr key={material.materialId}>
                  <td style={{ backgroundColor: "#fff" }}>{index + 1}</td>
                  <td style={{ backgroundColor: "#fff" }}>
                    {material.materialName}
                  </td>
                  <td style={{ backgroundColor: "#fff" }}>
                    {material.materialQuantity}
                  </td>
                  <td style={{ backgroundColor: "#fff" }}>
                    {material.materialCost}
                  </td>
                  <td style={{ backgroundColor: "#fff" }}>
                    {material.materialCost * material.materialQuantity}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default OrderedMaterials;
